import React from 'react'

const NotFound = () => {
  return <div className=" bg-red-50 text-black">NotFound</div>
}

export default NotFound
